<template>
	<div class="App">
		<Navbar />
			<transition name="fade" mode="out-in">
				<router-view class="router" />
			</transition>
		<Footer />
	</div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import translations from '@/translations'

export default {
	components: {
		Navbar,
		Footer
	},
	beforeMount() {
		this.setLanguages()
	},
	methods: {
		setLanguages() {
			this.$i18n.add('bs', translations.bs)
			this.$i18n.add('de', translations.de)
		}
	}
}
</script>

<style lang="scss">
.router {
	min-height: 85vh;
}

// TRANSITION EFFECT
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.15s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
